<router-outlet></router-outlet>


<!-- Modal-->
<div class="modal fade" id="waitingDialog" tabindex="-1" role="dialog" style="background-color: #000; opacity: 0.85; z-index: 10000 !important;" aria-labelledby="myModalLabel" aria-hidden="true">
    <div class="modal-dialog" style="text-align: center">

        <img src="assets/images/preloader.gif" style="padding-top:45%;" />
        <div class="modal-content" style="background: transparent">
            <div class="modal-body">
                <button type="button" id="btnCloseWaiting" style="display: none" class="btn btn-outline-light pull-right" data-dismiss="modal">OK</button>
            </div>

        </div>

    </div>
</div>

<div class="modal fade" id="dlgMainError">
    <div class="modal-dialog">
        <div class="modal-content bg-danger">
            <div class="modal-header">
                <h4 class="modal-title">Error !</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">X</span>
                </button>
            </div>
            <div class="modal-body">
                <p id="lblMainError"></p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-outline-light pull-right" data-dismiss="modal">OK</button>
            </div>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>

<div class="modal fade" id="dlgMainWarning">
    <div class="modal-dialog">
        <div class="modal-content bg-warning">
            <div class="modal-header">
                <h4 class="modal-title">Warning !</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">X</span>
                </button>
            </div>
            <div class="modal-body">
                <p id="lblMainWarning"></p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-outline-dark pull-right" data-dismiss="modal">OK</button>
            </div>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>

<div class="modal fade" id="dlgMainSuccess">
    <div class="modal-dialog">
        <div class="modal-content bg-success">
            <div class="modal-header">
                <h4 class="modal-title">Success</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">X</span></button>
            </div>
            <div class="modal-body">
                <p id="lblMainSuccess"></p>
            </div>
            <div class="modal-footer">
                <button type="button" id="btnSuccessOK" class="btn btn-outline-light pull-right" style="float: right !important" data-dismiss="modal">OK</button>
            </div>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>

<div class="modal fade" id="dlgMainConfirm">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Confirm</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
            </div>
            <div class="modal-body textcenter">
                <p class="input-text" id="lblMainConfirmMessage"></p>
            </div>
            <div class="modal-footer">
                <button type="button" id="btnMainConfirm" class="btn-form btn-form-primary" data-dismiss="modal">ยืนยัน</button>
                <button type="button" id="btnMainCancel" class="btn-form btn-form-default pull-left" data-dismiss="modal">ยกเลิก</button>
            </div>
        </div>
    </div>
</div>
<!-- /.modal -->


// WEBPACK FOOTER //
// ./src/app/app.component.html